/**
 * Resolves a REACT_APP_* value at runtime first (window.__ENV__, populated by
 * /env-config.js from the current App Service Application Settings), falling
 * back to the build-time process.env value for local dev where that script
 * isn't served.
 */
export function getRuntimeEnv(key: string): string | undefined {
  return window.__ENV__?.[key] || process.env[key];
}
